/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · French (fr) string table · dr-ronlan.html
   English is the source of truth in the HTML; this file supplies the
   French counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-fr.js.
   Proper names, institution names, journal titles, patent numbers and
   molecular names stay in their original form.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.fr = window.TD_I18N.fr || {};
  Object.assign(window.TD_I18N.fr, {

    /* ── Meta ── */
    'ronlan.docTitle': 'Dr K. Alvin Ronlán · Recherche et parcours — Transderma',

    /* ── Page header ── */
    'ronlan.headLabel': 'Recherche et parcours',
    'ronlan.headTitle': 'Dr K. Alvin <em>Ronlán</em>',
    'ronlan.headSub': 'Fondateur, Director of R&amp;D. Trois décennies de chimie des phénols, désormais appliquées à la peau.',

    /* ── Quick facts ── */
    'ronlan.facts.label': 'En bref',
    'ronlan.facts.bornK': 'Naissance',
    'ronlan.facts.bornV': '15 août 1942, Copenhague, Danemark',
    'ronlan.facts.domK': 'Résidence',
    'ronlan.facts.domV': 'Floride, États-Unis',
    'ronlan.facts.langK': 'Langues',
    'ronlan.facts.langV': 'Danois, suédois, anglais, allemand',
    'ronlan.facts.roleK': 'Poste actuel',
    'ronlan.facts.roleV': 'R&amp;D Director, Alron Chemical Co AB · Cofondateur, ProBios Laboratories, Inc.',

    /* ── Education ── */
    'ronlan.eduLabel': 'Formation',
    'ronlan.eduTitle': 'Quatre diplômes,<br><em>trois pays.</em>',
    'ronlan.edu1h': 'B.Sc. · mathématiques, physique, chimie',
    'ronlan.edu1p': 'Université de Copenhague et Institut technique du Danemark.',
    'ronlan.edu2h': 'M.Sc. · physique et chimie',
    'ronlan.edu2p': 'Université d\'Uppsala, Suède.',
    'ronlan.edu3h': 'Ph.D.',
    'ronlan.edu3p': 'Royal Institute of Technology, Stockholm, Suède.',
    'ronlan.edu4h': 'Docteur ès sciences',
    'ronlan.edu4p': 'Université de Lund, Suède.',

    /* ── Career ── */
    'ronlan.carLabel': 'Carrière',
    'ronlan.carTitle': 'De l\'académie<br><em>au laboratoire.</em>',
    'ronlan.carIntro': 'Six décennies d\'enseignement, de recherche et de chimie appliquée. Les points forts ci-dessous.',
    'ronlan.car1h': 'Assistant, Université d\'Uppsala',
    'ronlan.car1p': 'Premier poste d\'enseignement durant ses études de master.',
    'ronlan.car2h': 'Assistant de recherche, Royal Institute of Technology, Stockholm',
    'ronlan.car2p': 'Ses années de doctorat à Stockholm.',
    'ronlan.car3h': 'Docent, Université de Lund',
    'ronlan.car3p': 'Démarre les travaux sur la chimie des phénols et l\'oxydation anodique qui sous-tendront plus tard la formulation Transderma.',
    'ronlan.car4h': 'Maître de conférences, Université de Lund',
    'ronlan.car5h': 'Professeur, Université de Lund',
    'ronlan.car5p': 'Promu professeur de chimie bioorganique, dirige le groupe de recherche sur les antioxydants phénoliques et les radicaux cationiques.',
    'ronlan.car6h': 'Directeur du département de chimie, Université de Lund',
    'ronlan.car6p': 'Dirige le département de chimie de l\'Université de Lund.',
    'ronlan.car7h': 'Director of R&amp;D, Alron Chemical Co AB',
    'ronlan.car7p': 'En cours · fonde le laboratoire en 1977 pour la chimie et la physique des surfaces et la catalyse de combustion. La même année, Alron Japan, Inc. est aussi fondée à Tokyo.',
    'ronlan.car8h': 'Professeur invité, University of California, Santa Cruz',
    'ronlan.car8p': 'Applique l\'intelligence artificielle naissante à des problèmes chimiques et biochimiques.',
    'ronlan.car9h': 'Cofondateur et R&amp;D Director, ProBios Laboratories, Inc.',
    'ronlan.car9p': 'Avec Graziella Gallelli Ronlan. Recherche et développement basés en Floride.',
    'ronlan.car10h': 'Consultant, Erco Pharmaceuticals',
    'ronlan.car10p': 'Coauteur de brevets sur des produits de contraste et des médicaments antihypertenseurs.',
    'ronlan.car11h': 'Expédition en Afrique de l\'Est',
    'ronlan.car11p': 'A organisé et dirigé une expédition de quatre mois au Kenya, en Tanzanie et en Ouganda pour la collecte de plantes médicinales.',

    /* ── Publications ── */
    'ronlan.pubLabel': 'Publications sélectionnées',
    'ronlan.pubTitle': 'Phénols, antioxydants,<br><em>radicaux cationiques.</em>',
    'ronlan.pubIntro': 'Dix articles à comité de lecture qui montrent la chimie sous-jacente aux formulations Transderma. La bibliographie complète de 31 articles est disponible dans le téléchargement du CV.',
    'ronlan.pub1': '<em>Phenol Dehydrogenation. Intramolecular Oxidative Coupling of Dihydropiceatannol.</em> Acta Chem. Scand., 23, 249 (1969). Avec Holger Erdtman.',
    'ronlan.pub2': '<em>The Structure of Mezerein, A Major Toxic Principle of Daphne Mezerum L.</em> Tetrahedron Letters, 1970, 4261. Avec Börje Wickberg.',
    'ronlan.pub3': '<em>Coupling of Phenols via an Anodically Generated Ion.</em> Chem. Commun., 1971, 1643.',
    'ronlan.pub4': '<em>Anodic Oxidation of Phenolic Compounds. Part II. Products and Mechanisms of the Anodic Oxidation of Hindered Phenols.</em> J. Chem. Soc., C, 1971, 3241. Avec V.D. Parker.',
    'ronlan.pub5': '<em>Kinetics and Mechanisms of the Reaction of Organic Cation Radicals and Dications.</em> J. Amer. Chem. Soc., 96, 5108 (1974). Avec V.D. Parker et U. Svanholm.',
    'ronlan.pub6': '<em>Anodic Oxidation of Phenolic Compounds. Part V. Anodic Methoxylation of Phenols.</em> J. Chem. Soc. Perk I, 1978, 696.',
    'ronlan.pub7': '<em>Anodic Coupling of Simple Aryl Ethers.</em> Tetrahedron Letters, 1972, 2272.',
    'ronlan.pub8': '<em>The Direct Observation of Intermediates During the Oxidative Cyclization of Phenol Ethers.</em> Acta Chem. Scand., 1974.',
    'ronlan.pub9': '<em>Electrosynthesis of Medium and Large Sized Rings by Oxidative Cyclization.</em> J. Org. Chem., 39, 1014 (1974).',
    'ronlan.pub10': '<em>The Relative Ease of Oxidation of Phenols and Phenol Ethers.</em> Acta Chem. Scand., 1976.',
    'ronlan.pub11': '<em>Systematic Derivation of Chemical Procedures for Transforming Surplus Hazardous Chemicals to Useful Products.</em> Journal of Hazardous Materials, 1984.',
    'ronlan.pubFull': 'La bibliographie complète de 31 articles à comité de lecture est disponible dans le téléchargement du CV.',

    /* ── Patents ── */
    'ronlan.patLabel': 'Brevets',
    'ronlan.patTitle': 'Sept brevets,<br><em>un central pour la peau.</em>',
    'ronlan.patFeatBadge': 'La base de Transderma',
    'ronlan.patFeatTitle': 'US Pat. 20080118449 · Cosmetic Formulations of Piceatannol and Retinoids and Methods of Use Thereof',
    'ronlan.patFeatBody': 'Ce brevet est la base chimique de Transderma. Le piceatannol est le principe actif du Serum R ; les rétinoïdes (palmitate de rétinyle) sont le principe actif du Serum A. Le brevet décrit comment ces deux molécules agissent ensemble sur la peau.',
    'ronlan.patFeatLinkA': 'Acheter Serum R',
    'ronlan.patFeatLinkB': 'Acheter Serum A',
    'ronlan.pat1': 'US Pat. 6,500,465 · Composition désinfectante et sporicide · décontamination de bâtiments.',
    'ronlan.pat2': 'US Pat. 5,540,767 · Composition et méthode d\'équilibrage de pneus.',
    'ronlan.pat3': 'US Pat. 5,431,726 · Composition d\'équilibrage.',
    'ronlan.pat4': 'US Pat. 4,867,792 · Composition d\'équilibrage de pneus.',
    'ronlan.pat5': 'European Patent EP1196299 · Compositions d\'équilibrage de pneus.',
    'ronlan.pat6': 'European Patent EP0281252 · Composition et méthode d\'équilibrage de pneus.',

    /* ── Shop CTA ── */
    'ronlan.ctaLabel': 'La chimie appliquée',
    'ronlan.ctaTitle': 'Le brevet est<br><em>dans le flacon.</em>',
    'ronlan.ctaBody': 'Deux des cinq sérums Transderma viennent directement du brevet cosmétique du Dr Ronlán. Commence par là, ou essaie le système entier dans le Discovery Kit.',
    'ronlan.ctaBtnR': 'Serum R · Piceatannol',
    'ronlan.ctaBtnA': 'Serum A · Rétinoïde',
    'ronlan.ctaBtnKit': 'Discovery Kit · les cinq',

    /* ── PDF download footer ── */
    'ronlan.dlNote': 'Tu préfères le document original ?',
    'ronlan.dlLink': 'Télécharger le CV complet (PDF) →'

  });
})();
